/*
 * methods for dealing with the filters object
 * methods for setting filters from a hash
 * methods for creating a hash
 *
 * parent component needs:
 * - a filtersDefaults element
 * - a "filters" data element, initially set to filter defaults
 *
 */

// import FilterDictionary from "@/assets/js/cls/FilterDictionary";

export default {
  data: () => ({
    // filters: { ...FilterDictionary.filterDefaults },
    //rxHash: null,
    // initialSetup: false,
    prepend_F: true, // prepends an "f_" to filter values that will be placed in the URL, to avoid conflicts with values being sent to the API (was an issue with CL stuff)
    keysCase: "upper", // for some reason I made all keys upper case originally - set to "lower" to override this
    arrayFilterKeys: [], // a list of keys who's values will be arrays. These will be a comma separated list in the hash so it'll need to be converted to an array in the filter (example: a list of tags)
  }),
  methods: {
    // checks to see if the field has a default value and returns it
    // if not, returns null
    getDefaultForKey(key) {
      if (this.filterDefaults[key]) return this.filterDefaults[key];
      return null;
    },
    // takes the filter values
    // returns null for empty values
    // makes strings lower case
    formatValueForHash(val) {
      let rtn = null;
      if (val === null || val == "" || val == 0) return null;
      if (typeof val === "string") {
        if (val != "") rtn = val.toLowerCase();
      } else if (Array.isArray(val)) {
        if (val.length > 0) rtn = val;
      } else if (val) {
        rtn = 1;
      }
      return rtn;
    },
    // only return the values that are different than the defaults
    // only return values that are not empty strings or arrays
    // make string values lowercase
    // put arrays in alphabetical order ?
    hashParts() {
      let hash = window.location.hash.substring(1);
      if (!hash) return null;
      return this.paramStringToObject(hash);
    },

    caseForItem(item) {
      if (!item) return null;
      return this.keysCase == "lower" ? item.toLowerCase() : item.toUpperCase();
    },

    paramStringToObject(str) {
      let pieces = str.split("&");
      let data = {},
        parts;
      // process each query pair
      for (let i = 0; i < pieces.length; i++) {
        parts = pieces[i].split("=");
        if (parts.length < 2) {
          parts.push("");
        }
        data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
      }
      return data;
    },
    objectToParamString(obj, appendEye = null) {
      let arr = [];
      for (let objectKey in obj) {
        let paramKey = objectKey;
        if (appendEye) paramKey += appendEye.toUpperCase();
        arr.push(`${paramKey}=${obj[objectKey]}`);
      }
      let str = arr.join("&");
      return str;
    },

    hashValForKey(key) {
      // console.log(key);
      let hashParts = this.hashParts();
      if (!hashParts) return null;
      if (!hashParts[key]) return null;
      return hashParts[key];
    },

    // prepending an "f_" to any filters because the hash is sometimes sent right to the API
    // if the hash contained a filter like "replace=dailies" it was confusing the Api (which expected a number or array of numbers)

    updateFiltersInHash(filterObj) {
      // console.log("updateFiltersInHash - obj:", filterObj);
      // let hash = "";
      // let hashArr = [];
      let includedKeys = [];
      let newObj = {};

      for (let key in filterObj) {
        let f_key = this.prepend_F ? `f_${key}` : key;
        includedKeys.push(f_key);
        let val = filterObj[key];
        let formatted = this.formatValueForHash(val);
        if (formatted) newObj[f_key] = formatted; //hashArr.push(`${f_key}=${formatted}`);
        // if (hashParts[f_key]) delete hashParts[f_key];
        // }
      }
      // don't remove old stuff that was already in the hash (unless it has been replaced by a new filter)
      let hashParts = this.hashParts();
      for (let key in hashParts) {
        if (!includedKeys.includes(key)) newObj[key] = hashParts[key];
        // hashArr.push(`${key}=${hashParts[key]}`);
      }

      let hash = this.objectToParamString(newObj);
      // console.log(hash);
      this.updateHashWithParamString(hash);
    },

    updateHashWithParamString(hash) {
      // if (hash == "") return;
      hash = "#" + hash;
      if (history.pushState) {
        history.pushState(null, null, hash);
      } else {
        location.hash = hash;
      }
    },

    // see above re: the "f_" prefix
    setFiltersFromHash() {
      // console.log("setting filters");
      let hashObj = this.hashParts();
      // console.log("hashObj", hashObj);
      for (let f_key in hashObj) {
        let key = f_key.replace("f_", "");
        if (!(key in this.filters)) continue;
        // console.log("setFiltersFromHash(): " + key + " " + hashObj[f_key]);
        // console.log(this[key]);
        let val = this.caseForItem(hashObj[f_key]);
        if (this.arrayFilterKeys.includes(key)) val = val.split(",");
        this.filters[key] = val;
      }
      // if (this.filters?.bifocal == 0)
      //console.log("replace: " + this.replace);
    },

    resetFilters() {
      for (let [key, value] of Object.entries(this.filterDefaults)) {
        this.filters[key] = value;
        // this.updateFiltersInHash(this.filters); // redundant with watcher?
      }
    },
    setFilterToDefault(key) {
      let val = this.filterDefaults[key];
      if (!val) val = null;
      this.filters[key] = val;
      // this.updateFiltersInHash(this.filters); // redundant with watcher?
    },
    setFilterValue(what, val) {
      // console.log(what, val);
      this.filters[what] = val;
    },
    hashHasAdd() {
      let rtn = false;
      if (this.hashValForKey("bifocal") == 0) return false;
      if (this.hashValForKey("add")) rtn = true;
      if (this.hashValForKey("addOD")) rtn = true;
      if (this.hashValForKey("addOS")) rtn = true;
      return rtn;
    },
    hashHasCompany() {
      if (this.hashValForKey("comp_id")) return this.hashValForKey("comp_id");
      if (this.hashValForKey("comp_id[]"))
        return this.hashValForKey("comp_id[]");
      if (this.hashValForKey("comp_slug"))
        return this.hashValForKey("comp_slug");
      if (this.hashValForKey("company")) return this.hashValForKey("company");
      return false;
    },
    replaceCompanyInHash(company_const) {
      // "ALL" or "MAIN" or "FAVORITES"
      let obj = this.hashParts();
      delete obj.comp_id;
      delete obj["comp_id[]"];
      delete obj.comp_slug;
      delete obj.company;
      let newParamString = this.objectToParamString(obj);
      newParamString += "&company=" + company_const;
      this.updateHashWithParamString(newParamString);
    },
    // prepareHashForApit() {
    //   let obj = this.hashParts();
    // },
  },
  computed: {
    dirtyFilter: function () {
      let dirty = 0;
      // console.log("f", this.filters);
      if (!this.filters) return 0;
      for (let [key, value] of Object.entries(this.filters)) {
        let defaultValue =
          this.filterDefaults && this.filterDefaults[key]
            ? this.filterDefaults[key]
            : null;
        if (value && value != "" && value != defaultValue) dirty++;
      }
      return dirty;
    },
    // allFilters: function () {
    //   let allFilters = {};
    //   for (let [key, value] of Object.entries(this.filterDefaults)) {
    //     allFilters[key] =
    //       this.filters && this.filters[key] ? this.filters[key] : value;
    //   }
    //   return allFilters;
    // },
  },
  watch: {
    filters: {
      handler: function (newFilters) {
        this.updateFiltersInHash(newFilters);
      },
      deep: true,
    },
  },

  mounted() {},
};
